module.exports = __webpack_public_path__ + "static/media/shadow.33d8726e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/shadow.png
// module id = 281
// module chunks = 0